ul.pagination.pagination-sm
  li.g-page-prev.disabled
    a &laquo; Prev
  li.active
    a.g-page-number Page #{collection.pageNum() + 1}
  li.g-page-next.disabled
    a Next &raquo;
